import React from 'react';
import { motion } from 'framer-motion';

const ClientsSection: React.FC = () => {
  const clients = [
    {
      name: 'Government of Goa',
      logo: '/Logo-1.jpg',
      category: 'Government'
    },
    {
      name: 'Tourism Development Corporation',
      logo: '/Logo-2.jpg',
      category: 'Tourism'
    },
    {
      name: 'Entertainment Society of Goa',
      logo: '/Logo-3.jpg',
      category: 'Entertainment'
    },
    {
      name: 'Goa State Pollution Control Board',
      logo: '/Logo-4.jpg',
      category: 'Government'
    },
    {
      name: 'Goa Electronics Ltd',
      logo: '/Logo-5.jpg',
      category: 'Corporate'
    },
    {
      name: 'International Film Festival of India',
      logo: '/Logo-6.jpg',
      category: 'Entertainment'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <section className="py-20 bg-white dark:bg-dark-bg">
      <div className="container-grid">
        <div className="col-span-12 text-center mb-16">
          <motion.h2
            className="text-4xl lg:text-5xl font-bold text-neutral-900 dark:text-white mb-6"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            Our Clients
          </motion.h2>
          <motion.p
            className="text-lg text-neutral-600 dark:text-neutral-400 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            From government agencies to leading companies, we've earned the trust of prestigious organizations across diverse sectors.
          </motion.p>
        </div>

        <motion.div
          className="col-span-12"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-12">
            {clients.map((client, index) => (
              <motion.div
                key={client.name}
                variants={itemVariants}
                className="group flex flex-col items-center"
              >
                <div className="w-full flex items-center justify-center mb-4">
                  <img
                    src={client.logo}
                    alt={`${client.name} Logo`}
                    className="max-w-full object-contain transition-all duration-300 hover:scale-105 logo-color-preserve"
                    onError={(e) => {
                      console.error(`Failed to load image: ${client.logo}`);
                      e.currentTarget.style.display = 'none';
                    }}
                  />
                </div>
                <p className="text-center text-xs text-neutral-500 dark:text-neutral-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {client.category}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ClientsSection;